import { gql } from "@apollo/client";

export const GET_PROFIT_ALERT_LIST_TODAY = gql`
  query ProfitAlertListToday {
    profitAlertListToday {
      userId
      userName
      recommendCode
      authority
      dailyProfitNLoss
      triggeredAt
      dateId
    }
  }
`;

export const SUBSCRIBE_PROFIT_ALERT = gql`
  subscription SubscribeProfitAlert {
    subscribeProfitAlert {
      userId
      userName
      recommendCode
      authority
      dailyProfitNLoss
      triggeredAt
      dateId
    }
  }
`;
